// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0bd4dd7c","598":"7420285c","703":"bdc3a08a"}[chunkId] + ".chunk.js";
};